import { useParams } from 'react-router-dom';

import type { RouteParam } from '@/types';

import { useBoard } from './boards-hooks';
import { useCurrentChannel } from './query/useCurrentChannel';

export const useCurrentFeedName = () => {
  const { source } = useParams<RouteParam>();

  const board = useBoard();
  const channel = useCurrentChannel();

  return board.board_name || channel.name || source || 'home';
};
